import styled from 'styled-components';
import { colors, fontSizes, fontWeights } from './theme';
export const StyledText = styled.p `
  color: ${props => colors[props.color]};
  font-size: ${props => fontSizes[props.size] || fontSizes.root}px;
  font-weight: ${props => fontWeights[props.weight] || fontWeights.regular};
  text-align: ${props => props.align};
  line-height: ${props => props.lineHeight};
  text-transform: ${props => props.textTransform};
  margin: 0;
`;
export const StyledTitle = styled.h2 `
  color: ${props => colors[props.color]};
  font-size: ${props => fontSizes[props.size] || fontSizes.root}px;
  font-weight: ${props => fontWeights[props.weight] || fontWeights.regular};
  text-align: ${props => props.align};
`;
export const StyledScreenReaderText = styled.span `
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  width: 1px;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
`;
//# sourceMappingURL=text.js.map